import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'features/store';
import { ConnectedUserInState, User } from 'services/auth/auth.types';

export type AuthState = {
    isLogged: boolean;
    user: ConnectedUserInState | null;
};

const initialAuthState: AuthState = {
    isLogged: false,
    user: null
};

export const authSlice = createSlice({
    name: 'authentication',
    initialState: initialAuthState,
    reducers: {
        login: (state, action: PayloadAction<ConnectedUserInState>) => {
            state.isLogged = true;
            state.user = action.payload;
        },
        logout: (state) => {
            localStorage.removeItem('persist:root');
            state.isLogged = false;
            state.user = null;
        },
        update: (state, action: PayloadAction<User>) => {
            state.user = { ...state.user, ...action.payload } as ConnectedUserInState;
        }
    }
});
export const getIsLogged = (state: RootState) => state.authentication.isLogged;
export const getUser = (state: RootState) => state.authentication.user;
export const getJwtToken = (state: RootState) => state.authentication.user?.jwt;
export const getPrivacyPolicyRead = (state: RootState) => state.authentication.user?.privacy_policy_read;
export const { login, logout, update } = authSlice.actions;

export default authSlice.reducer;
